import React from 'react';

/**
 * Shows a "Back to Home" bar when the catalog was opened from the Customer Dashboard.
 * Reads return_url from the URL search params.
 */
function DashboardReturnBar() {
  const params = new URLSearchParams(window.location.search);
  const returnUrl = params.get('return_url');

  if (!returnUrl) return null;

  return (
    <div className="dashboard-return-bar">
      <a href={returnUrl} className="dashboard-return-link">
        ← Back to Home
      </a>
    </div>
  );
}

export default DashboardReturnBar;
